// extracted by mini-css-extract-plugin
export default {"featureBlocks":"MSKrZ"};